import { axiosInstance } from "../axios";

export const approvalPermissionApi = {
  getAll: async () => {
    return await axiosInstance.get("/approval-configurations");
  },
  getAllForms: async () => {
    return await axiosInstance.get("/approval-configurations/forms");
  },
  getById: async (id) => {
    return await axiosInstance.get(`/approval-configurations/${id}`);
  },
  create: async (body) => {
    return await axiosInstance.post("/approval-configurations", body);
  },
  update: async (id, body) => {
    return await axiosInstance.put(`/approval-configurations/${id}`, body);
  },
  updateStatus: async (id) => {
    return await axiosInstance.put(`/approval-configurations/${id}/status`);
  },
  getApprovalGroupsByType: (type) =>
    axiosInstance.get(`/approval-configurations/forms/${type}/approval-groups`),
};
